import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.35355 2.64645C7.15829 2.45118 6.84171 2.45118 6.64645 2.64645C6.45118 2.84171 6.45118 3.15829 6.64645 3.35355L8.79289 5.5H2C1.72386 5.5 1.5 5.72386 1.5 6C1.5 6.27614 1.72386 6.5 2 6.5H8.79289L6.64645 8.64645C6.45118 8.84171 6.45118 9.15829 6.64645 9.35355C6.84171 9.54882 7.15829 9.54882 7.35355 9.35355L10.3536 6.35355C10.5488 6.15829 10.5488 5.84171 10.3536 5.64645L7.35355 2.64645Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.80474 3.52827C9.54439 3.26792 9.12228 3.26792 8.86193 3.52827C8.60158 3.78862 8.60158 4.21073 8.86193 4.47108L11.7239 7.33301H2.66667C2.29848 7.33301 2 7.63148 2 7.99967C2 8.36786 2.29848 8.66634 2.66667 8.66634H11.7239L8.86193 11.5283C8.60158 11.7886 8.60158 12.2107 8.86193 12.4711C9.12228 12.7314 9.54439 12.7314 9.80474 12.4711L13.8047 8.47108C14.0651 8.21073 14.0651 7.78862 13.8047 7.52827L9.80474 3.52827Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.2559 4.41107C11.9305 4.08563 11.4028 4.08563 11.0774 4.41107C10.752 4.73651 10.752 5.26414 11.0774 5.58958L14.6548 9.16699H3.33333C2.8731 9.16699 2.5 9.54009 2.5 10.0003C2.5 10.4606 2.8731 10.8337 3.33333 10.8337H14.6548L11.0774 14.4111C10.752 14.7365 10.752 15.2641 11.0774 15.5896C11.4028 15.915 11.9305 15.915 12.2559 15.5896L17.2559 10.5896C17.5814 10.2641 17.5814 9.73651 17.2559 9.41107L12.2559 4.41107Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.64648 2.64637C6.82954 2.46331 7.11904 2.45201 7.31543 2.61219L7.35352 2.64637L10.3535 5.64637C10.5488 5.84163 10.5488 6.15814 10.3535 6.3534L7.35352 9.3534C7.15825 9.54866 6.84175 9.54866 6.64648 9.3534C6.45122 9.15814 6.45122 8.84163 6.64648 8.64637L8.79297 6.49988H2C1.72386 6.49988 1.5 6.27603 1.5 5.99988C1.5 5.72374 1.72386 5.49988 2 5.49988H8.79297L6.64648 3.3534L6.6123 3.31531C6.45213 3.11893 6.46343 2.82943 6.64648 2.64637Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.86198 3.52816C9.10606 3.28409 9.49206 3.26902 9.75391 3.48259L9.80469 3.52816L13.8047 7.52816C14.065 7.78851 14.065 8.21052 13.8047 8.47087L9.80469 12.4709C9.54434 12.7312 9.12233 12.7312 8.86198 12.4709C8.60163 12.2105 8.60163 11.7885 8.86198 11.5282L11.724 8.66618H2.66667C2.29848 8.66618 2 8.36771 2 7.99952C2 7.63133 2.29848 7.33285 2.66667 7.33285H11.724L8.86198 4.47087L8.81641 4.42009C8.60284 4.15824 8.6179 3.77224 8.86198 3.52816Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0775 4.41094C11.3826 4.10584 11.8651 4.08701 12.1924 4.35397L12.2559 4.41094L17.2559 9.41094C17.5813 9.73637 17.5813 10.2639 17.2559 10.5893L12.2559 15.5893C11.9304 15.9148 11.4029 15.9148 11.0775 15.5893C10.752 15.2639 10.752 14.7364 11.0775 14.4109L14.6549 10.8335H3.33333C2.8731 10.8335 2.5 10.4604 2.5 10.0001C2.5 9.53989 2.8731 9.1668 3.33333 9.1668H14.6549L11.0775 5.58932L11.0205 5.52585C10.7535 5.19853 10.7724 4.71603 11.0775 4.41094Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconArrowNarrowRight: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"arrow-narrow-right"} {...props} />
);
